export const MINUTES_STEP = 15
